import { MarqueeComponentUi } from "ui";
import useAllQueuesQuery from "../../apis/tryst/get-all-queues";
import useQueueStore from "../../stores/queue-store";
import { Appointment } from "@elixir/types";
import { useMemo } from "react";
import { AllQueuesData } from "@elixir/types";
import { getAptsForDoctor } from "../../utils/appointment-utils";
import useGetAppointmentLastUpdatedAt from "../../apis/idb/get-apt-last-fetch";
import { getAllAptSubscribers } from "../../utils/firestore-utils/apt-listener-manager";
import dayjs from "dayjs";
import getB from "../../utils/bridges/EkaBridge";

const BottomMarquee = ({ hideFinanceData }: { hideFinanceData?: boolean }) => {
  const openLeftPanel = useQueueStore((state) => state.openLeftPanel);
  const selectedDate = useQueueStore((state) => state.selectedDate);
  const selectedDoctor = useQueueStore((state) => state.selectedDoctor);
  const isSyncing = useQueueStore((state) => state.isSyncing);
  const clinicId = useQueueStore((state) => state.clinicId);
  const date = useQueueStore((state) => state.selectedDate);
  const isNetworkOnline = useQueueStore((state) => state.isNetworkOnline);

  const { data: lastSyncedTime } = useGetAppointmentLastUpdatedAt({
    clinicId,
    date,
  });

  const { data = {} } = useAllQueuesQuery();

  const filteredByDoctorApt = useMemo(() => {
    return Object.keys(data as AllQueuesData).reduce((acc, key) => {
      const _key = key as keyof AllQueuesData;
      const filterByDoctor = getAptsForDoctor({
        apts: data?.[_key] || [],
        doctor_oid: selectedDoctor?.oid || "",
      });
      acc[_key] = filterByDoctor;
      return acc;
    }, {} as AllQueuesData);
  }, [data, selectedDoctor?.oid]);

  const uniqueApts = useMemo(() => {
    const uniqueAids = new Set<string>();
    const uniqueApts: Appointment[] = [];
    Object.values(filteredByDoctorApt).forEach((apts) => {
      apts?.forEach((apt) => {
        if (uniqueAids.has(apt.aid)) return;
        uniqueAids.add(apt.aid);
        uniqueApts.push(apt);
      });
    });

    return uniqueApts;
  }, [filteredByDoctorApt]);

  return (
    <MarqueeComponentUi
      openLeftPanel={openLeftPanel}
      data={uniqueApts}
      isSyncing={isSyncing || !lastSyncedTime}
      lastSyncDate={lastSyncedTime!}
      onSync={() => refreshQueue(clinicId, selectedDate)}
      isOnline={isNetworkOnline}
      hideFinanceData={hideFinanceData}
    />
  );
};

export default BottomMarquee;

export const refreshQueue = async (clinicId: string, selectedDate: Date) => {
  await getB().getIdb().appointments.clear();
  await getB().getIdb().todayAppointments.clear();

  const listener = getAllAptSubscribers().find(
    (item) => item.clinicId === clinicId &&
      dayjs(item.date).isSame(selectedDate, "day")
  );
  
  if (listener) {
    listener.establishNewListener();
  }
}
